import { DEFAULT } from 'conversations-message-history/constants/messageUses';
import MessageUse from 'conversations-message-history/proptypes/MessageUse';
import PropTypes from 'prop-types';
import { memo } from 'react';
import invariant from 'react-utils/invariant';
import Theme from '../model/Theme';
import { defaultThemeConfig } from '../contexts/ThemeConfigContext';
import ThemeContext from '../contexts/ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
const validateConfig = config => {
  invariant(config === undefined || typeof config === 'object', 'Invalid config type given');
  if (!config) {
    return;
  }
  Object.values(config).forEach(value => {
    invariant(typeof value === 'object', 'All themes in the configuration must be a `Theme` object. Found %s', typeof value);
  });
};
/**
 * Uses a given theme configuration and a message use to determine which theme to show. If no theme
 * can be found by its use, will attempt to use the `DEFAULT` theme from the configuration file. If
 * the configuration file does not contain a `DEFAULT`, will construct a new `Theme` object and use
 * the object's default values.
 */
const ThemeProvider = /*#__PURE__*/memo(({
  themeConfig,
  use,
  children
}) => {
  validateConfig(themeConfig);
  themeConfig = Object.assign({}, defaultThemeConfig, themeConfig);
  const theme = use ? themeConfig[use] : themeConfig[DEFAULT] || Theme();
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: theme,
    children: children
  });
});
ThemeProvider.displayName = 'ThemeProvider';
ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  themeConfig: PropTypes.object,
  use: MessageUse
};
export default ThemeProvider;